import {
  required,
  helpers,
  numeric,
  // email,
  minLength,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

const offerLetterMixin = {
  data: {
    addques1: false,
    candres: 3,
    LoaderStatus: false,
    allselectedcand: [],
    enableEditing: false,
    deptopt: false,
    status: null,
    remarks: "",
    date: "",
    offerletter: {
      firstName: "",
      middleName: "",
      lastName: "",
      experince: "",
      email: "",
      phoneNumber: "",
      altPhoneNumber: "",
      dateOfBirth: "",
      dateOfJoining: "",
      expectedCTC: "",
      currentCTC: "",
      offeredCTC: "",
      employerAddress: "",
      department: "",
      designation: "",
      noticePeriod: "",
      gender: "",
      note: "",
      highestQualification: "",
    },

    JobTypeoptions: [
      { text: "Select Job Type", value: null, disabled: true },
      "Temporary Resource",
      "Full time",
      "Freelancer",
      "Contract",
    ],

    Departments: [
      { name: "Front End Developer", value: "FrontEndDeveloper" },
      { name: "Back End Developer", value: "BackEndDeveloper" },
      { name: "Graphics designer", value: "GraphicsDesigner" },
      { name: "Tester", value: "Tester" },
    ],

    Designations: [
      { text: "Select Roles", value: null, disabled: true },
      { text: "Tester", value: "Tester" },
      { text: "Developer", value: "Developer" },
      { text: "Others", value: "Others" },
    ],
    isAddNotesChecked: false,
    editorConfig: {
      toolbar: [["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"]],
    },
  },

  validations() {
    return {
      offerletter: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        offeredCTC: {
          required,
          numeric,
        },
        phoneNumber: {
          required,
          maxLength: maxLength(10),
          minLength: minLength(7),
          alpha: helpers.regex("alpha", /^\d{7,10}$/),
        },
        dateOfBirth: {
          required,
        },
        dateOfJoining: {
          required,
        },
        department: {
          required,
        },
        employerAddress: {
          required,
        },
        jobType: {
          required,
        },
        designation: {
          required,
        },
        experince: {
          required,
        },
        note: {
          required: requiredIf(function () {
            return this.isAddNotesChecked;
          }),
          maxLength: maxLength(1024),
        },
      },
    };
  },
  created() {
    this.getOfferDetails();
  },
  computed: {
    ...mapGetters("hrPortalReferenceVUEX", {
      selectCandidate: "saveSelectCandidate",
    }),
    dateDisabled() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      let dd = String(today.getDate()).padStart(2, "0");
      // 15th two months prior
      let minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      minDate.setDate(dd);
      return minDate;
    },
  },
  methods: {
    validateText(val) {
      this.dirtyCheckDescQuestion = val;
    },
    updateQuestionContent(newContent) {
      this.testConfigData.config.testDesc = newContent;
    },
    changedaddQues(newval) {
      this.addques1 = newval;
    },
    gotoback() {
      this.$router.push({
        name: this.$route.query.redirect,
      });
    },
    hidedepartmentoptions() {
      this.deptopt = false;
    },
    departmentfunction() {
      this.deptopt = true;
      this.$forceUpdate();
    },
    gotodob() {
      this.$refs.dob.$el.children[0].click();
    },
    gotodoj() {
      this.$refs.doj.$el.children[0].click();
    },
  },
};
export default offerLetterMixin;
